import { styled } from "@mui/material/styles";
import { ButtonBase, ButtonBaseProps, Theme } from "@mui/material";
import { StyledComponent } from "@emotion/styled";
import { Colors } from '@sweatpals/react-ui-kit';

export type CoreButtonVariant = 'primary' | 'secondary' | 'danger';

export interface CoreButtonBaseProps extends ButtonBaseProps {
	variant?: CoreButtonVariant;
}

export const getTextColor = (variant: CoreButtonVariant, theme: Theme) => {
	switch (variant) {
		case "danger":
			return Colors.white;
		case "primary":
			return Colors.black;
		case "secondary":
			return Colors.white;
	}
};

export const getBackgroundColor = (variant: CoreButtonVariant, theme: Theme) => {
	switch (variant) {
		case "danger":
			return Colors.red;
		case "primary":
			return Colors.white;
		case "secondary":
			return 'transparent';
	}
};

export const getFocusTextColor = (variant: CoreButtonVariant, theme: Theme) => {
	switch (variant) {
		case "danger":
			return Colors.white;
		case "primary":
			return Colors.white;
		case "secondary":
			return Colors.black;
	}
};

export const getFocusBackgroundColor = (variant: CoreButtonVariant, theme: Theme) => {
	switch (variant) {
		case "danger":
			return Colors.redPressed;
		case "primary":
			return 'transparent';
		case "secondary":
			return Colors.white;
	}
};

export const CoreButtonBase: StyledComponent<CoreButtonBaseProps> = styled(ButtonBase)<CoreButtonBaseProps>(({ theme, variant = 'primary' }) => {
	const { typography, transitions } = theme;

	const textColor = getTextColor(variant, theme);
	const backgroundColor = getBackgroundColor(variant, theme);
	const focusTextColor = getFocusTextColor(variant, theme);
	const focusBackgroundColor = getFocusBackgroundColor(variant, theme);

	return {
		...typography.button,
		textTransform: 'none',
		lineHeight: '24px',
		fontSize: '14px',
		color: textColor,
		backgroundColor,
		border: `1px solid ${textColor}`,
		borderRadius: '100px',
		padding: '12px 32px',
		boxSizing: 'border-box',
		fontFamily: 'Integral CF, sans-serif',

		transition: transitions.create(['background-color', 'color', 'border-color'], {
			duration: transitions.duration.short
		}),
		'&:hover, &.Mui-focusVisible, &.core-button-loading': {
			color: focusTextColor,
			backgroundColor: focusBackgroundColor,
			borderColor: focusTextColor
		},
		'&:active': {
			color: focusTextColor,
			backgroundColor: focusBackgroundColor,
		},
		'&.Mui-focusVisible': {
			borderColor: focusTextColor
		},
		'&:disabled:not(.core-button-loading)': {
			color: Colors['4A4A4A'],
			backgroundColor: Colors['191919'],
			borderColor: Colors['191919'],
		}
	};
});
